import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTikTokWb = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 61,
	height: 60,
	viewBox: "0 0 61 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M54.2001 57.9001H6.8001C4.4601 57.9001 2.6001 56.0401 2.6001 53.7001V6.3001C2.6001 3.9601 4.4601 2.1001 6.8001 2.1001H54.2001C56.5401 2.1001 58.4001 3.9601 58.4001 6.3001V53.7001C58.4001 56.0401 56.5401 57.9001 54.2001 57.9001ZM6.8001 2.7001C4.8201 2.7001 3.2001 4.3201 3.2001 6.3001V53.7001C3.2001 55.6801 4.8201 57.3001 6.8001 57.3001H54.2001C56.1801 57.3001 57.8001 55.6801 57.8001 53.7001V6.3001C57.8001 4.3201 56.1801 2.7001 54.2001 2.7001H6.8001Z",
		fill: "#3F3F3F"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M35.9599 23.3399V34.3199C35.9599 34.9199 35.96 35.4599 35.9 36.1199C35.18 41.8199 29.9599 45.8399 24.2599 45.0599C18.5599 44.3399 14.54 39.1199 15.32 33.4199C16.04 27.7199 21.2599 23.6999 26.9599 24.4799V30.4199C26.4799 30.2999 26.06 30.2399 25.64 30.2399C23.12 30.2399 21.02 32.2799 21.02 34.7999C21.02 37.3199 23.0599 39.3599 25.5799 39.3599C28.0999 39.3599 30.14 37.3199 30.14 34.7999V12.4199H35.9599V12.4799C35.9599 13.1399 36.2 19.9199 43.7 20.2199V25.9199C43.7 26.0399 38.66 25.7999 35.9599 23.3399Z",
		fill: "#3F3F3F"
	})]
});
export default SvgTikTokWb;
